import {
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  Provider,
} from '@angular/core';
import { AppSettingsService } from './providers/config.provider';
export const APP_SETTINGS = new InjectionToken('APP_SETTINGS');

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createAppSettingsService(settings: CoreModuleOptionsInterface) {
  return new AppSettingsService(settings);
}

export interface CoreModuleOptionsInterface {
  appConstants: any;
  environment: any;
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
})
export class CoreModule {
  static forRoot(
    config: CoreModuleOptionsInterface
  ): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: APP_SETTINGS, useValue: config },
        {
          provide: AppSettingsService,
          // useValue: new AppSettingsService(config),
          useFactory: createAppSettingsService,
          deps: [APP_SETTINGS],
        },
        ...config.providers,
      ],
    };
  }
}
